import React from "react";
import { Cake } from "lucide-react";

export function BirthdayBadge({ birthday, className = "w-4 h-4" }) {
  if (!birthday) return null;
  return (
    <span
      title="Birthday today! 🎂"
      aria-label="Birthday today"
      data-testid="birthday-badge"
      className="inline-flex items-center shrink-0"
    >
      <Cake className={`text-fuchsia-400 ${className}`} />
    </span>
  );
}
